import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { useT } from "@/lib/translation";
import {
  sendContactMessage,
  sendAuthContactMessage,
  type ContactFormData,
} from "@/api/client";

export function useContactForm(
  onSuccessCallback?: () => void,
  mode: "public" | "auth" = "public",
) {
  const t = useT();
  return useMutation<void, Error, ContactFormData>({
    mutationFn: (payload) =>
      mode === "auth"
        ? sendAuthContactMessage(payload)
        : sendContactMessage(payload),
    onSuccess: () => {
      toast.success(t("contact:toast.sent"));
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error) => {
      const description = error.message || t("contact:toast.sendFailed");
      toast.error(t("contact:toast.sendFailedTitle"), {
        description,
      });
    },
  });
}
